import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { headerEmpresa } from "../../helpers/headerEmpresa";
import { getEmpresa } from "../../../services/empresaService";

async function finalizadoraPDF(finalizadoras) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const empresa = await getEmpresa();

    const fixNull = (v) => (v === null || v === undefined || v === "" ? "Não informado" : v);

    const reportTitle = [
        {
            text: "Relatório de Finalizadoras",
            fontSize: 18,
            bold: true,
            alignment: "center",
            margin: [0, 10, 0, 25]
        }
    ];

    const makeInfoRows = (f) => {
        const rows = [
            { label: "Descrição impressão", value: fixNull(f.DESC_IMP) },
            { label: "TEF", value: fixNull(f.TEF_DESCRICAO) },
            { label: "Parcelas", value: fixNull(f.NR_PARCELAS) },
            { label: "Conta bancária", value: fixNull(f.CONTA_BANCARIA) },
            { label: "Permite troco", value: fixNull(f.PERMT_TROCO) },
            { label: "Gera Titulos a receber", value: fixNull(f.GERCR) },
            { label: "Gera Lanc.Bancário", value: fixNull(f.GERBCO) },
            { label: "Gera Cartão", value: fixNull(f.GERCCD) },
            { label: "Totaliza", value: fixNull(f.GERTOTAL) },
            { label: "Usa Acréscimo/desconto", value: fixNull(f.USA_AD) },
            { label: "Tipo adicional", value: fixNull(f.TIPO_AD) },
            { label: "Acréscimo", value: fixNull(f.ACRESCIMO) },
            { label: "Desconto", value: fixNull(f.DESCONTO) },
            { label: "Valor mínimo", value: fixNull(f.VLR_MINIMO_OP) },
            { label: "Cartão", value: fixNull(f.CARTAO) },
            { label: "Juros", value: fixNull(f.JUROS) },
            { label: "Sintético", value: fixNull(f.SINTETICO_DESCRICAO) },
            { label: "Analítico", value: fixNull(f.ANALITICO_DESCRICAO) },
            { label: "Tipo Movimento", value: fixNull(f.TIPO_MOVIMENTO) },
            {label: "Tipo Doc", value: fixNull(f.TIPO_DOC)}
        ];

        return rows;
    };

    const cards = finalizadoras.map((f) => {
        const rows = makeInfoRows(f);

        const mid = Math.ceil(rows.length / 2);

        const col1 = rows.slice(0, mid).map(r => ({ text: `${r.label}: ${r.value}`, margin: [0, 2, 0, 2] }));
        const col2 = rows.slice(mid).map(r => ({ text: `${r.label}: ${r.value}`, margin: [0, 2, 0, 2] }));

        return {
            style: "card",
            table: {
                widths: ["100%"],
                body: [
                    [
                        {
                            stack: [
                                { text: `${f.DESCRICAO} (${f.COD_FINALIZADORA})`, style: "cardTitle" },
                                {
                                    columns: [
                                        {
                                            width: "50%",
                                            stack: col1
                                        },
                                        {
                                            width: "50%",
                                            stack: col2
                                        }
                                    ],
                                    columnGap: 20
                                }
                            ]
                        }
                    ]
                ]
            },
            layout: {
                fillColor: () => "#F7F7F7",
                paddingLeft: () => 15,
                paddingRight: () => 15,
                paddingTop: () => 10,
                paddingBottom: () => 10
            },
            margin: [0, 0, 0, 20]
        };
    });

    const docDefinitions = {
        pageSize: "A4",
        pageMargins: [20, 60, 20, 40],
        header: headerEmpresa(empresa),
        
        content: [reportTitle, cards],

        footer: (currentPage, pageCount) => [
            {
                text: `${currentPage} / ${pageCount}`,
                alignment: "right",
                margin: [0, 10, 20, 0],
                fontSize: 9
            }
        ],

        styles: {
            cardTitle: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            card: {
                margin: [0, 10, 0, 10]
            }
        }
    };

    pdfMake.createPdf(docDefinitions).open();
}

export default finalizadoraPDF;
